import { render, staticRenderFns } from "./AiChatBot.vue?vue&type=template&id=54ac5c69&scoped=true"
import script from "./AiChatBot.vue?vue&type=script&lang=js"
export * from "./AiChatBot.vue?vue&type=script&lang=js"
import style0 from "./AiChatBot.vue?vue&type=style&index=0&id=54ac5c69&prod&lang=sass&scoped=true"
import style1 from "./AiChatBot.vue?vue&type=style&index=1&id=54ac5c69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ac5c69",
  null
  
)

export default component.exports